angular
  .module('percentCoupons')
  .component('percentCoupons', {
    template: require('./percent-coupons.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function PercentCouponsViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'coupons';
        $rootScope.menu = 'percent';
        $scope.doLogout = $rootScope.gLogout;
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.coupons = {};
        this.total_count = 0;
        this.query = '';
        $resource(`${APIURL}/admin/percent/coupons`).get({ q: this.query }).$promise
          .then((data) => {
            this.coupons = data.coupons;
            this.total_count = data.total_count;
            console.log('11');
            console.log(this.coupons);
            console.log(this.total_count);
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/percent/coupons`).get({ page: page - 1, q: $scope.query },
            (data) => {
              console.log(data);
              this.coupons = data.coupons;
              this.total_count = data.total_count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.delete = (coupon) => {
          console.log(coupon.COUPON_COUNT);
          const isGroup = !!(coupon.COUPON_COUNT && coupon.COUPON_COUNT > 1);
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/percent/coupons/${isGroup ? coupon.GROUP_ID : coupon.ID}`).delete({ isGroup },
            () => {
              alert($translate.instant('삭제되었습니다'));
              this.coupons.splice(this.coupons.indexOf(coupon), 1);
              jQuery('#modal-coupon').removeClass('fade');
              jQuery('#modal-coupon').modal('hide');
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.showGroupCoupons = (coupon) => {
          this.group_coupon_id = coupon.GROUP_ID;
          this.group_coupons_download_url = `${APIURL}/admin/percent/coupons/group/${coupon.GROUP_ID}.csv`;
          $resource(`${APIURL}/admin/percent/coupons/group/${coupon.GROUP_ID}`).get((data) => {
            this.group_coupons = data.coupons;
            this.group_coupons_total_count = data.total_count;
            jQuery('#modal-coupon').modal('show');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.pagingGroupCoupons = (page) => {
          $resource(`${APIURL}/admin/percent/coupons/group/${this.group_coupon_id}`).get({ page: page - 1 }, (data) => {
            this.group_coupons = data.coupons;
            this.group_coupons_total_count = data.total_count;
          }, (err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/percent-coupons/percent-coupons.component.js